function sort () {
    const sortBtns = document.querySelectorAll('.sort-btn')

    if (sortBtns.length > 0) {
        const sortItems = document.querySelectorAll('.sort-item')

        sortBtns[0].classList.add('active')
        sortItems[0].classList.add('show')

        sortBtns.forEach((btn) => {
            btn.addEventListener('click', function () {
                sortBtns.forEach((el) => el.classList.remove('active'))
                this.classList.add('active')

                const btnCategory = this.dataset.sortCategory

                sortItems.forEach((el) => {
                    el.classList.remove('show')

                    if(el.dataset.sortCategory === btnCategory) {
                        el.classList.add('show')
                    }
                })
            })
        })
    }
}

export default sort;